interface Props {
  label: string;
  onClick: () => void;
}

/**
 * "Replace source file" trigger rendered in the configurator page
 * header. Opens ``ReplaceFileModal`` (the actual upload + carryover
 * flow lives there). Process-agnostic — caller passes the right label
 * (laser: "Nahradit DXF", 3D: "Nahradit STL", etc.).
 */
export function ReplaceFileButton({ label, onClick }: Props): JSX.Element {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex h-9 items-center gap-2 rounded-md border border-border-strong bg-surface px-3 text-sm text-ink hover:bg-surface-2"
      data-testid="replace-file"
    >
      <UploadIcon />
      <span>{label}</span>
    </button>
  );
}

function UploadIcon(): JSX.Element {
  return (
    <svg
      viewBox="0 0 16 16"
      className="h-3.5 w-3.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      aria-hidden="true"
    >
      <path d="M8 11 V3 M5 6 L8 3 L11 6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 12 V13 H13 V12" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
